export const conceptQuenames = {
	agreement: "S1",
	excludeIndustries: "S2",
	gender: "S3",
	age: "S4",
	married: "S5",
	family: "S6",
	occupation: "S7",
	skinAttribute: "S8",
	sensitiveSkin: "S9",
	sensitiveSkinFrequency: "SQ9",
	skinProblemFrequency: "S10",
	category: "S11",
	facewashFunction: "SQ11-1",
	foundationType: "SQ11-2",
	lipstickType: "SQ11-3",
	eyeshadowType: "SQ11-4",
	price: "S12",
	channel: "S13",
	usedBrand: "S14",
	useBrand: "S15",
	beautyType: "S16",
	gypsy: "S17",
	aestheticMedicineExperience: "S18",
	lastFace: "E7",
	sourceOfInfo: "Q8",
	concept: "C1",
	isBoost: "C2",
	purchaseIntent: "Q1",
	skuPurchase: "Q2",
	conceptImpression: "Q3",
	evaluation: "Q4",
	elementEvaluationMA: "Q5",
	elementEvaluationSA: "Q6",

	cosmeticsExpenditure: "Q7",
	sourceOfInformation: "Q8",

	marketMaven: "MQ1",

	prefecture: "Q9",

	personalIncome: "Q10",
	householdIncome: "Q11",
} as const;
